import { Link } from '@tanstack/react-router';
import classNames from 'classnames';
import type React from 'react';

// Extra anchor props and the ref pass through so a Tooltip `asChild` can compose onto the link.
type Props = Omit<React.ComponentPropsWithRef<'a'>, 'href' | 'className' | 'style'> & {
  to: string;
  // Query to carry to the target; a `Link` without `search` drops the current query entirely.
  search?: Record<string, unknown>;
  isActive?: boolean;
  highlight?: boolean;
  children?: React.ReactNode;
  dataTestId?: string;
};

export default function ({ to, search, isActive, children, highlight, dataTestId, ...props }: Props) {
  return (
    <Link
      {...props}
      to={to}
      search={search}
      data-testid={dataTestId}
      className={classNames(
        'flex min-w-[8rem] cursor-pointer flex-nowrap items-center justify-center overflow-clip border-b border-r p-2 last:border-r-0 hover:bg-brand-light',
        {
          'border-b-2 border-b-brand font-medium text-brand': isActive,
          'text-primary': !isActive,
        },
      )}
      style={{
        ...(highlight && {
          background:
            'linear-gradient(to bottom, rgba(255,0,0,0.3), rgba(255,165,0,0.3), rgba(255,255,0,0.3), rgba(0,128,0,0.3), rgba(0,0,255,0.3), rgba(128,0,128,0.3))',
        }),
      }}
    >
      {children}
    </Link>
  );
}
